import { useEffect, useState } from 'react';

import { FormField, FormHelp, Textarea } from '@zillow/constellation-10';

type Props = {
  initialValue?: string;
  isDisabled?: boolean;
  maxLength?: number;
  // eslint-disable-next-line
  onClearError?: (value?: any) => void;
  handleCaptionBlur: (value: string) => void;
};

export const TextareaHelper = ({
  initialValue = '',
  isDisabled = false,
  maxLength = 255,
  onClearError,
  handleCaptionBlur,
}: Props) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onClearError) {
      onClearError();
    }
    setValue(e.target.value);
  };

  const handleOnBlur = () => {
    handleCaptionBlur(value);
  };

  return (
    <FormField>
      <Textarea
        aria-label="Image Description"
        placeholder="Describe this photo"
        maxLength={maxLength}
        value={value}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        disabled={isDisabled}
        css={{ marginBlock: '200' }}
      />

      <FormHelp>Max {maxLength} characters</FormHelp>
    </FormField>
  );
};
